import { Input } from '@multaqa/ui/components/ui/input'
import { Label } from '@multaqa/ui/components/ui/label'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@multaqa/ui/components/ui/select'
import { Switch } from '@multaqa/ui/components/ui/switch'

export function SettingsNumberField({
  id,
  label,
  value,
  onChange,
  min = '0',
  max,
}: {
  id: string
  label: string
  value: string
  onChange: (value: string) => void
  min?: string
  max?: string
}) {
  return (
    <div className="grid gap-1.5">
      <Label htmlFor={id}>{label}</Label>
      <Input
        id={id}
        type="number"
        min={min}
        max={max}
        numeric
        value={value}
        onChange={(event) => onChange(event.target.value)}
      />
    </div>
  )
}

export function SettingsSelectField({
  id,
  label,
  value,
  options,
  onChange,
}: {
  id: string
  label: string
  value: string
  options: { value: string; label: string }[]
  onChange: (value: string) => void
}) {
  return (
    <div className="grid gap-1.5">
      <Label htmlFor={id}>{label}</Label>
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger id={id} data-testid={`${id}-trigger`}>
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {options.map((option) => (
            <SelectItem key={option.value} value={option.value}>
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  )
}

export function SettingsToggleField({
  id,
  label,
  checked,
  onChange,
}: {
  id: string
  label: string
  checked: boolean
  onChange: (checked: boolean) => void
}) {
  return (
    <div className="flex min-h-8 items-center justify-between gap-3">
      <Label htmlFor={id}>{label}</Label>
      <Switch id={id} checked={checked} onCheckedChange={onChange} />
    </div>
  )
}

export function SettingsReadOnlyGrid({ rows }: { rows: [string, string][] }) {
  return (
    <div className="grid gap-x-6 sm:grid-cols-2">
      {rows.map(([label, value]) => (
        <div key={label} className="border-b border-border py-3">
          <div className="text-label text-muted-foreground font-mono uppercase">{label}</div>
          <div className="text-body font-mono break-all">{value}</div>
        </div>
      ))}
    </div>
  )
}

export function settingBooleanLabel(value: boolean, t: (key: string) => string) {
  return value ? t('companies.settings.values.enabled') : t('companies.settings.values.disabled')
}
